import type { ReactNode } from 'react';

/** Numbers every `###` heading inside it as a step (counter styles in `docs.css`). */
export function Steps({ children }: { children: ReactNode }) {
  return (
    <div className="docs-steps my-6 ml-3.5 border-l pl-10 [&>h3]:mt-8 [&>h3:first-child]:mt-0">
      {children}
    </div>
  );
}
